import { AfterViewInit, Component, ElementRef, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as c3 from 'c3';
import { OEEGrapgData } from '../../../models/factory-summary';
const monthnames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

@Component({
  selector: 'app-oee-and-change-over-popup',
  templateUrl: './oee-and-change-over-popup.component.html',
  styleUrls: ['./oee-and-change-over-popup.component.scss']
})
export class OeeAndChangeOverPopupComponent implements OnInit, AfterViewInit {
  @ViewChild('lineGraphOEEDiv') lineGraphOEEDiv: ElementRef;
  @Output() factorySummary = new EventEmitter<any>();
  @Output() currentDate = new EventEmitter<any>();
  @Output() currrentFilter = new EventEmitter<any>();
  public oneDateOne: any;
  public monthNameName: any;
  currentEndWeek: any;
  emitDataListLi: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data
  ) { }

  ngOnInit() {
    const daDate1 = this.getLocalStorageData('selectedDATimeFilter');
    this.currentEndWeek = '';
    this.emitDataListLi = {
      appliedFilterType: daDate1 ? daDate1.appliedFilterType : '',
      dateObj: new Date(daDate1.endOfMonth),
      selectedHr: daDate1.selectedHr,
      endWeekFromSelectedDate: daDate1.endWeekFromSelectedDate,
      startQuarterMonth: null
    };
    this.oneDateOne = this.emitDataListLi.dateObj;
    this.monthNameName = this.oneDateOne.toLocaleString('en-us', { month: 'short' });
  }
  getLocalStorageData(key: string) {
    return JSON.parse(sessionStorage.getItem(key));
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.data) {
        // this.data['xAxisLabels'] = ['x'].concat(this.data.xAxisLabels);
        // this.data['oeeData'] = ['oee'].concat(this.data.oeeData);
        // this.data['costPercentageData'] = ['cost'].concat(this.data.costPercentageData)
        this.generateOEEGraph();
      }
    }, 0);
  }

  generateOEEGraph() {

    c3.generate({
      bindto: this.lineGraphOEEDiv.nativeElement,
      size: {
        height: 400,
        width: 800
      },
      data: {
        x: 'x',
        columns: [
          this.data.xAxisLabels,
          this.data.oeeData,
          this.data.costPercentageData
        ],
        // axes: {
        //   waste: 'y2'
        // },
        colors: {
          oee: '#D26999',
          cost: '#72A8D5'
        },
        names: {
          oee: 'OEE %',
          cost: 'Cost %'
        }
      },
      line: {
        connectNull: true
      },
      point: {
        show: false
      },
      axis: {
        x: {
          label: {
            text: 'Month',
            position: 'outer-center'
          },
          show: true
        },
        y: {
          label: {
            text: 'Percentage',
            position: 'outer-middle'
          },
          show: true,
          tick: {
            format: ((y) => y + '%'),
            outer: true,
          }
        },
        y2: {
          show: true,
          // max: 100,
          // min: 0,
          // padding: { top: 0, bottom: 0 },
          tick: {
            format: ((y) => y + '%'),
            values: [],
            outer: true,
          }
        }
      },
      tooltip: {
        format: {
          title: (x: number) => (this.emitDataListLi &&
            (this.emitDataListLi.appliedFilterType === 'quarter' || this.emitDataListLi.appliedFilterType === 'year'
              || this.emitDataListLi.appliedFilterType === 'month') ? monthnames[x - 1] :
            (x + ' ' + this.monthNameName + ' ')),
          value: (x: number) => x.toFixed(2) + '%'
        }
      },
    });
  }

}
